<template>
  <div id="app">
    <Chat/>
  </div>
</template>

<script>
import Chat from './components/Chat.vue'
import { initSoundUnlock } from '@/api/soundManager';

export default {
  name: 'App',
  components: {
    Chat
  },
  mounted() {
    initSoundUnlock();
  }
}
</script>

<style>
html, body{
  margin: 0;
  width: 100%;
  height: 100%;
}
p,
h1,
h2{
  margin: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2A2A2A;
  width: 100%;
  height: 100%;
  font-size: 14px;
  box-sizing: border-box;
  overflow: hidden;
}
</style>
